module.exports = __webpack_public_path__ + "static/media/ferry.8ff50125.png";